<template>
<div class="formArea_section">
    <div class="container">
        <div class="title_form">
            <h1 class="t2">SEND OSS EN MELDING</h1>
            <p class="desc">We offer the highest-quality auto detailing service in Norway, using the best equipment and products, and the most modern processes and techniques.</p>
        </div>
        <form @submit.prevent="submit_contact()">
            <div class="row">
                <div class="col-12">
                     <div class="center content-inputs">
                    <vs-input v-model="name" required placeholder="Full Name" />
                </div>
                </div>
                <div class="col-12">
                     <div class="center content-inputs">
                    <!-- <vs-input v-model="email" type="email" required placeholder="Email Address" /> -->
                    <vs-input v-model="email"  placeholder="Email Address">
                        <template v-if="validEmail" #message-success>
                        Email Valid
                        </template>
                        <template v-if="!validEmail && email !== ''" #message-danger>
                        Email Invalid
                        </template>
                    </vs-input>
                </div>
                </div>
                <div class="col-12">
                     <div class="center content-inputs">
                    <vs-input v-model="phone" required placeholder="Phone" />
                </div>
                </div>
                <div class="col-12">
                     <div class="center content-inputs">
                    <vs-input v-model="subject" required placeholder="Subject" />
                </div>
                </div>
                <div class="col-12">
                     <div class="center content-inputs">
                      <textarea v-model="message" required class="form-control" placeholder="Your Message *"></textarea>
                </div>
                </div>
                <div class="col-12 btnss">
                     <vs-button type="submit" :loading='isloading' :disabled="!validEmail || email=='' || name=='' || phone=='' || subject=='' || message==''">
                      Send Message <i class='bx bxs-send' ></i>
                    </vs-button>
                </div>
            </div>
        </form>
    </div>
</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "formArea",
  data(){
    return{
      isloading:false,
        name:'',
        email:'',
        phone:'',
        message:'',
        subject:''
    }
  },
   computed:{
    ...mapGetters({
        get_contact_data:'get_contact_data',
        get_contact_form:'get_contact_form',
        get_contact_info:'get_contact_info'
    }),
     validEmail() {
            return /[a-zA-Z0-9.]*@[a-z]*[.a-z]*/.test(this.email);
        }
  },
  methods: {
    ...mapActions({
        contact_data_api:'contact_data_api',
        contact_form_api:'contact_form_api',
        contact_info_api:'contact_info_api'
    }),
    submit_contact(){
        this.isloading= true;
        let my_form={
        'name':this.name,
        'email':this.email,
        'phone':this.phone,
        'message':this.message,
        'subject':this.subject
        }
        this.contact_form_api(my_form).then(()=>{
            if(this.get_contact_form.status==201 || this.get_contact_form.status==200){
                 this.name = '';
                this.email = '';
                this.phone= '';
                this.message='';
                 this.subject='';
                 this.openNotification('bottom-right', 'success' , 'Sent successfully' , 'Sent successfully, thank you')
                this.isloading= false;
            }else{
                 this.openNotification('bottom-right', 'danger' , 'error occurred' , 'Try sending again !!');
            }
        })
    },
          // Notifucation
      openNotification(position = null, color , title , text) {
      this.$vs.notification({
        color,
        position,
        title: title,
        text: text,
      });
    },

  },
  mounted() {
    document.body.classList.add("contact_wrap");
    this.contact_data_api();
    this.contact_info_api();
  },
}
</script>
<style lang="scss" scoped>
.formArea_section{
    padding: 80px 0px 0px 0px;
     background-image: url("~@/assets/what2.svg");
     background-position: bottom right;
    background-repeat: no-repeat;
    background-size: 20vw auto;
    .container{
        background-image: url("~@/assets/car.png");
            background-position: center right;
    background-repeat: no-repeat;
    background-size: contain;
    }
.title_form{
max-width: 600px;
text-align: left;
margin-bottom: 25px;
display: block;
}
form{
    max-width: 720px;
    .content-inputs{
        margin-bottom: 20px;
    }
    textarea{
        width: 100%;
    height: 140px;
    padding: 12px 10px;
    font-size: 12px;
    background-color: rgba(255, 255, 255, 0.716);
    transition: all 0.35s ease;
    &:focus{
        background-color: white;
    }
    &:hover{
        background-color: white;
    }
    }
    button{
    background-color: rgba(0, 0, 0, 0.599);
    border-radius: 0px;
    border: 1px solid var(--active_color);
    padding: 4px 20px;
    font-size: 14px;
    font-weight: 600;
    i{
        padding-left: 8px;
    }
    }
}
}
@media(max-width:767px){
    .formArea_section{
    padding: 10px 0px 0px 0px;
}
}
</style>